export default __webpack_public_path__ + "static/media/user-plus-circle-yellow.cc2e5c71.svg";